// import _ from 'lodash';
import { axiosAPI } from '@/axios';

const loadComponentById = (pageKey, componentKey) => {
  return axiosAPI.get(`/design/pages/${pageKey}/components/${componentKey}`);
};

const loadPageDesignerByKey = (pageKey) => {
  return axiosAPI.get(`/design/pages/${pageKey}`);
};

const loadDesignerMenuList = () => {
  return axiosAPI.get('design/pages');
};

const updateComponentById = (pageKey, componentKey, component) => {
  return axiosAPI.put(`/design/pages/${pageKey}/components/${componentKey}`, component);
};

const loadPopup = () => {
  return axiosAPI.get('popup');
};

const updatePopup = (payload) => {
  return axiosAPI.put('popup/edit', payload);
};

export {
  loadPageDesignerByKey,
  loadDesignerMenuList,
  loadComponentById,
  updateComponentById,
  loadPopup,
  updatePopup,
};
